@.modalCustomizerHandler = ->
    $(document).ready(() ->
        showHideOptions()
        addToQuote()
        generateCAD()
        saveToMySpacestor()
        addNewProject()
        selectFilterEvents()
        selectRegionsEvents()
    )

    # Email validation
    validateEmail = (email) ->
        re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        re.test(email)

    validate = ->
        generateBtn = $(".jsModalCustomizerCadBtn")
        email = $(".jsModalCustomizerCadInput").val()
        generateBtn.attr('disabled', true)

        if validateEmail(email)
            generateBtn.removeAttr('disabled')
        else
            return false

    $(".jsModalCustomizerCadInput").on("keyup", validate)

    showHideOptions = ->
        title = $('.jsModalCustomizerOptionTitle')

        # show/ hide options
        title.each(() ->
            $(this).on('click', ->
                item = $(this).parents('.jsModalCustomizerOption')
                itemDesc = $(this).siblings('.jsModalCustomizerDesc')
                itemDesc.slideToggle('slow')

                if(item.hasClass('active'))
                    if(item.children('.jsModalCustomizerOptionTitle').hasClass('jsModalCustomizerAddQuote'))
                        return
                    else
                        item.removeClass('active')
                else
                    item.addClass('active')

                # if user is logged show another step
                if ($(this).attr('data-log') == 'true')
                    $('.jsModalCustomizerLoggedUser').show()
                    $('.jsModalCustomizerUnLoggedUser').hide()

                if $('.jsModalCustomizerSavedSuccessful').css('display') == 'block'
                    $('.jsModalCustomizerLoggedUser').hide()
            )
        )

        # hide option on click 'cancel'
        $('.jsModalCustomizerCancelBtn').each(() ->
            $(this).on('click', ->
                $(this).parents('.jsModalCustomizerOption').find(title).trigger('click')
            )
        )

    addToQuote = ->
        btnAdd = $('.jsModalCustomizerAddQuote')

        btnAdd.on('click', (e) ->
            e.preventDefault()
            if ($(this).attr('data-add') == 'false')
                btnThis = $(this)
                productId = $('#modalProductId').val()
                customizerData = JSON.stringify(configurator.serialize())
                customizerDimensions = configurator.get_dimensions()
                screenshot = configurator.save_screenshot()
                basket_data = {
                    'basket_action': 'add'
                    'object_type': 'design'
                    'productId': productId
                    'customizerData': customizerData
                    'customizerDimensions': customizerDimensions
                    'screenshot': screenshot
                    'pdfData': JSON.stringify(configurator.get_pdf_data()),
                }
                $.ajax({
                    type: 'POST'
                    url: '/myspacestor/quotebasket/change/'
                    data: basket_data
                    success: (data) ->
                        $(document).trigger('basketChanged')
                        btnThis.attr('data-add', 'true') # .text('Added to Quote')
                        $('.jsModalSlide').find('.jsModalSlideAddedProductBox').addClass('active')
                        setTimeout (->
                            $('.jsModalSlide').find('.jsModalSlideAddedProductBox').removeClass('active')
                        ), 3000
                    error: (data) ->
                        console.log('failure ' + data)
                    headers: {
                        'X-CSRFToken': getCookie('csrftoken')
                    }
                })
        )

    generateCAD = ->
        btnGenerate = $('.jsModalCustomizerCadBtn')
        btnGenerate.on('click', (e) ->
            $(this).attr('disabled', true)
            e.preventDefault()
            productId = $('.jsModalSlide').attr('data-product-id')
            customizerData = JSON.stringify(configurator.serialize())
            email = $('.jsModalCustomizerCadInput').val()
            customizerDesc = $(this).parents('.jsModalCustomizerDesc')
            customizerCad = $(this).parents('.jsModalCustomizerCad')

            $.ajax({
                type: 'POST'
                url: '/configurator/cad/'
                data: {
                    'productId': productId,
                    'customizerData': customizerData,
                    'pdfData': JSON.stringify(configurator.get_pdf_data()),
                    'email': email
                }
                success: (data) ->
                    customizerDesc.children().hide()
                    customizerDesc.children('.jsModalCustomizerCadGenerated').show()
                    customizerCad.find('.jsModalCustomizerOptionTitle') # .text('Generating CAD')
                    validate()
                error: (data) ->
                    console.log('failure ' + data)
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

    saveToMySpacestor = ->
        loginForm = $('.jsModalCustomizerLoginOption')
        showFormBtn = $('.jsModalCustomizerShowLogIn')

        # show form to sign in
        showFormBtn.on('click', ->
            showFormBtn.hide()
            $('.jsModalCustomizerCancelLogIn').hide()
            loginForm.slideDown('slow')
        )

        # Sign In
        $('.jsModalCustomizerSingIn').on('click', (e) ->
            e.preventDefault()
            username = $('#jsModalCustomizerLoginEmail').val()
            pass = $('#jsModalCustomizerLoginPassword').val()

            if username and pass
                $.ajax({
                    type: 'POST'
                    url: '/myspacestor/login/'
                    data: {
                        'username': username,
                        'password': pass
                    }
                    success: (data) ->
                        $('.jsModalCustomizerUserName').text('You have succesfully signed in as ' + username)
                        # Show select with regions only for root user
                        username == 'root' && $('.jsSelectRegionLabel').attr('data-visible', true)

                        $.ajax({
                            type: 'GET'
                            url: '/myspacestor/myprojects/dropdown/'
                            success: (data) ->
                                if data['content']
                                    addElement = '' +
                                        '<li class="customizer-options__item__desc__form__input__list__item jsSelectAddProj">' +
                                        'Add new project' +
                                        '</li>'
                                    $('.jsSlideList').html(data['content']).append(addElement)
                                    $('.jsModalCustomizerLoggedUser').show()
                                    $('.jsModalCustomizerUnLoggedUser').hide()
                                else
                                    $('.jsSelectAddProj').text(gettext('Add new preset'))
                                    $('#modalProductName').attr('placeholder', gettext('name your preset'))
                                    $('.jsModalFormTitle').text(gettext('Add new preset'))
                                    $('#proj-title-btn').removeClass('jsModalCustomizerAddProjectSubmit').addClass('jsModalCustomizerAddPresetSubmit')
                                    $('.jsModalCustomizerLoggedUser').show()
                                    $('.jsModalCustomizerUnLoggedUser').hide()

                            error: (data) ->
                                console.log('failure ' + data)
                            headers: {
                                'X-CSRFToken': getCookie('csrftoken')
                            }
                        })
                    error: (data) ->
                        console.log('failure ' + data)
                    headers: {
                        'X-CSRFToken': getCookie('csrftoken')
                    }
                })
        )

        # Save Project to MySpacestor
        $('.jsModalCustomizerSaveProject').on('click', (e) ->
            e.preventDefault()
            name = $('#modalProductName').val()
            presetId = $('#modalPresetId').val()
            projectId = $(this).parents('.jsModalCustomizerLoginOption').find("input[type='radio']:checked").val()
            projectTitle = $(this).parents('.jsModalCustomizerLoginOption').find("input[type='radio']:checked").parents('.jsSelectOption').text()
            regions = $(this).parents('.jsModalCustomizerLoginOption').find(".jsRegionsList").attr('data-regions')?.split(',')
            isSuperUser = $(this).parents('.jsModalCustomizerLoginOption').attr('data-staff') == "True"
            productId = $('#modalProductId').val()
            customizerData = JSON.stringify(configurator.serialize())
            customizerDimensions = configurator.get_dimensions()
            screenshot = configurator.save_screenshot()

            url = if( isSuperUser ) then '/configurator/presets/' else '/myspacestor/save-customizer/'
            $.ajax({
                type: 'POST'
                url
                data: {
                    name
                    presetId
                    projectId
                    productId
                    regions
                    customizerData
                    customizerDimensions
                    screenshot
                }
                success: (data) ->
                    $('.jsModalCustomizerLoggedUser').hide()
                    $('.jsModalCustomizerSavedSuccessful').show()
                    $('.jsModalCustomizerSavedSuccessfulText').text('You have succesfully saved Customizer ' + name + ' in Project ' + projectTitle)
                    $('.jsModalCustomizerSaveProject').parents('.jsModalCustomizerSaveMySpacestor').find('.jsModalCustomizerOptionTitle') # .text('Saved to MySpacestor')

                error: (data) ->
                    console.log('failure ' + data)
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

    addNewProject = ->
# Show Modal
        $('.jsSelectAddProj').on('click', ->
            $('.jsModalCustomizerAddProject').addClass('active')
            $('.jsModalCustomizerAddProject').show()

            # fit modal overlay to window
            if($(document).width() > $('.jsModalCustomizerAddProject').width())
                $('.jsModalCustomizerAddProject').css({
                    width: '100vw',
                    left: 'unset',
                })
        )

        # Add Project to MySpacestor
        $('.jsModalCustomizerAddProjectSubmit').on('click', (e) ->
            e.preventDefault()
            projTitle = $('.jsCustomizerModalAddProjTitleBtn').val()

            $.ajax({
                type: 'POST'
                url: '/myspacestor/add-project/'
                data: {
                    'projectName': projTitle
                }
                success: (data) ->
                    newProjId = data['projectData'].id
                    newProjName = data['projectData'].name
                    $('.jsSelectFilterReset').attr('data-product', newProjId)

                    element = '' +
                        '<li class="customizer-options__item__desc__form__input__list__item">' +
                        '<label class="jsSelectOption" for="' + newProjId + '">' +
                        '<input type="radio" name="project" id="' + newProjId + '" value="' + newProjId + '" class="jsSelectOptionInput">' +
                        newProjName +
                        '</label>' +
                        '</li>'
                    $('.jsSlideList').prepend(element)
                    $('.jsSlideList').find('li .jsSelectOptionInput[value="' + newProjId + '"]').parents('.jsSelectOption').trigger('click')
                    $('.jsModalCustomizerAddProject').find('.jsModalContentClose').trigger('click')

                error: (data) ->
                    console.log('failure ' + data)
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

        # Add Preset to MySpacestor
        $(document).on('click', '.jsModalCustomizerAddPresetSubmit', (e) ->
            e.preventDefault()
            projTitle = $('.jsCustomizerModalAddProjTitleBtn').val()
            customizerData = JSON.stringify(configurator.serialize())
            customizerDimensions = configurator.get_dimensions()
            screenshot = configurator.save_screenshot()
            $('.jsModalCustomizerAddProject').hide()

            $.ajax({
                type: 'POST'
                url: '/configurator/presets/'
                data: {
                    'name': projTitle
                    'presetId': $('#modalPresetId').val()
                    'productId': $('#modalProductId').val()
                    'customizerData': customizerData,
                    'customizerDimensions': customizerDimensions,
                    'screenshot': screenshot,

                }
                success: (data) ->
                    element = '' +
                        '<li class="customizer-options__item__desc__form__input__list__item">' +
                        '<label class="jsSelectOption" for="addedPreset">' +
                        '<input type="radio" name="addedPreset" id="addedPreset" value="addedPreset" class="jsSelectOptionInput">' +
                        projTitle +
                        '</label>' +
                        '</li>'
                    $('.jsSlideList').prepend(element)
                    $('.jsSlideList').find('li .jsSelectOptionInput[value="addedPreset"]').parents('.jsSelectOption').trigger('click')
                    $('.jsModalCustomizerAddProject').find('.jsModalContentClose').trigger('click')
                    $('#modalPresetId').val(data.id)

                error: (data) ->
                    console.log('failure ' + data)
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

    selectRegionsEvents = () ->
        list = $('.jsRegionsList');
        selectedRegionsList = $('.jsSelectedRegionsList');
        itemsList = $(list).children()
        regionsId = []
        regionsNames = []

        # Toggle show regions list
        $('.jsSelectedRegions').on('click', ()  => list.slideToggle())

        # Toggle select item
        itemsList.each((itemIndex, item ) =>
            $(item).on('click', (e) =>
                e.preventDefault()
                input = $(item).find('.jsSelectMultiOptionInput')
                itemId = $(input)[0].id
                itemName = $(input).attr('data-name')
                itemIndex = $.inArray(itemId, regionsId )

                if itemIndex == -1
                    regionsId.push(itemId)
                    regionsNames.push(itemName)
                else
                    regionsId.splice(itemIndex, 1 );
                    regionsNames.splice(itemIndex, 1 );

                # Set input text and color
                inputText = if regionsNames.length > 0 then regionsNames.join(', ') else "Choose region"
                selectedRegionsList.css({color: if regionsNames.length > 0 then '#1c1417' else '#777777' })

                selectedRegionsList.text(inputText)

                # Add selected regions as attribute to main wrapper
                list.attr('data-regions', regionsId )
            )
         )

    selectFilterEvents = () ->
        inputValue = '.jsSelectOption'
        filterType = '.jsSelectFilterType'
        filterName = '.jsSelectFilterName'
        filterReset = '.jsSelectFilterReset'

        #   choose item from filter list
        $(document).on('click', inputValue, ->
            $(this).parents(filterType).find(filterName).text($(this).text())
            $(this).parents(filterType).find(filterName).css('color', '#1c1417')

            if ($(this).parents(filterType).find(filterName).text() != 'Choose location')
                $(this).parents(filterType).find('.jsSlideList').slideUp()
                $(this).parents(filterType).find(filterReset).show()
                $(this).parents(filterType).find('.jsLinkButton').removeClass('active')
        )

        #   reset filter
        $(filterReset).on('click', (e) ->
            e.stopPropagation()
            $(this).hide()
            $(this).parents(filterType).find('.jsSlideList').slideUp()
            $(this).parents(filterType).find('.jsLinkButton').removeClass('active')

            if ($(this).parents(filterType).find('.jsSelectOptionInput').length > 0)
                $(this).siblings(filterName).text('Choose location').css('color', '#777777')
                $('input[name="project"]').each(() ->
                    $(this).prop('checked', false)
                )
                $('input[name="addedPreset"]').each(() ->
                    $(this).prop('checked', false)
                    $(this).parents('li').remove()
                )
        )

    # reset customizer modal options
    resetCustomizerModalOptions = (modalSlide) ->
        modal = modalSlide
        modalOption = modal.find('.jsModalCustomizerOption')
        modalOption.each(() ->
            if $(this).find('.jsModalCustomizerAddQuote').length > 0
                $(this).removeClass('active')
            else
                if $(this).hasClass('active')
                    $(this).find('.jsModalCustomizerOptionTitle').trigger('click')
        )
        # basket
        $('.jsModalCustomizerAddQuote').text('Quote Me').attr('data-add', 'false') # .text('Add to Quote')

        # cad
        $('.jsModalCustomizerCadInput').val('')
        cadDesc = $('.jsModalCustomizerCad').find('.jsModalCustomizerDesc')
        cadDesc.children().show()
        cadDesc.children('.jsModalCustomizerCadGenerated').hide()

        # myspacestor
        $('.jsModalCustomizerSaveMySpacestor').find('.jsModalCustomizerOptionTitle').text('Save for Later') # .text('Save to MySpacestor')
        $('.jsModalCustomizerSavedSuccessful').hide()
        $('.jsModalCustomizerLoggedUser').show()
        $('#modalProductName').val('')
        $('.jsSelectFilterReset').trigger('click')

    $('.jsModalSlideOverlay').on('click', ->
        resetCustomizerModalOptions($('.jsModalSlide'))
    )

    $('.jsModalContentResetOptions').on('click', ->
        resetCustomizerModalOptions($(this).parents('.jsModalSlide'))
        $('.jsModalSlideOverlay').trigger('click')
    )

    # spec tech in customizer modal
    specTechEvents = () =>
        specTech = $('.jsModalSlideSpecTech')
        specTechContainer = $('.jsModalSlideSpecTechContainer')
        showMoreBtn = $('.jsModalSlideShowMore')

        if specTech.height() > specTechContainer.height()
            specTechContainer.css({
                maxHeight: 176
            })
            showMoreBtn.parent().fadeIn()
        else
            showMoreBtn.parent().fadeOut()

        showMoreBtn.on('click', ->
            $(this).parent().fadeOut()
            specTechContainer.css({
                overflowY: 'auto',
                maxHeight: 168
            })
            if window.innerWidth <= window.gridBreakpoints.md
                specTechContainer.css({
                    flex: 1,
                    height: '100%'
                })
        )

    # template to spec tech
    descTemplate = (type, title, content, parent, accessoriesType) ->
        specTechContainer = $(parent)

        $(type).each(->
# Customizers have different JSON response (accessories). JSON response Object with elements or list with strings
            if accessoriesType
                elemList = []

                this[content].forEach((elem) ->
                    if typeof elem == 'object'
                        elemList.push(elem.join(': '))
                    else
                        elemList.push(elem)
                )
                contentList = elemList.join(', ')
            else
                contentList = this[content]

            if this[content].length > 0
                template = '' +
                    '<div class="modal-slide__content__left__desc__container__list">' +
                    '<span class="modal-slide__content__left__desc__container__list__title">' +
                    this[title] +
                    '</span>' +
                    ' <span class="modal-slide__content__left__desc__container__list__text">' +
                    contentList +
                    '</span>' +
                    '</div>'
                return specTechContainer.append(template)
        )

    # spec tech in customizer modal
    @.customizerPdfData = ->
        specTechContainer = '.jsModalSlideSpecTech'

        $.ajax({
            type: 'POST'
            url: '/configurator/pdf-data/'
            data: {
                'pdfData': JSON.stringify(window.configurator.get_pdf_data()),
            }
            success: (data) ->
                parameters = data['data'].parameters
                accessories = data['data'].accessories
                accessories2 = data['data'].accessories2
                accessories3 = data['data'].accessories3
                accessories4 = data['data'].accessories4
                accessories5 = data['data'].accessories5
                accessories6 = data['data'].accessories6
                fabrics = data['data'].fabrics
                $(specTechContainer).html('')
                descTemplate(parameters, 'heading', 'text', specTechContainer)
                descTemplate(accessories, 'heading', 'items', specTechContainer, true)
                descTemplate(accessories2, 'heading', 'items', specTechContainer)
                descTemplate(accessories3, 'heading', 'items', specTechContainer)
                descTemplate(accessories4, 'heading', 'items', specTechContainer)
                descTemplate(accessories5, 'heading', 'items', specTechContainer)
                descTemplate(accessories6, 'heading', 'items', specTechContainer)
                descTemplate(fabrics, 'heading', 'items', specTechContainer)
                specTechEvents()
                $(specTechContainer).fadeIn()
            error: (data) ->
                console.log('failure ' + data)
            headers: {
                'X-CSRFToken': getCookie('csrftoken')
            }
        })

    # Open modal I'm done
    $('.jsCustomizerBtnImDone').on('click', ->
        customizerImg = window.configurator.save_screenshot()

        # customize module in product page details (set zIndex in fullscreen)
        if $(this).parents('#customize')
            $('.jsHeaderNav').css({
                zIndex: '160000003'
            })

        # Main image in modal
        $('.jsModalCustomizerMainImage').attr('src', customizerImg)

        # Image in modal with added product to basket
        $('.jsModalCustomizerAddedProductImage').attr('src', customizerImg)

        $('.jsModalCustomizerOverlay').addClass('active')
        $('.jsModalSlideCustomizer').addClass('active')

        # clear spec tech in modal
        $('.jsModalSlideSpecTech').children().remove()

        # render new spec tech in modal
        customizerPdfData()
    )
